import React, { Component } from 'react';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link, withRouter } from 'react-router-dom';

import * as ROUTES from 'config/routes';
import { Col, Row } from 'elements';
import { detectablesListSelector } from 'redux/selectors';
import { getHolder } from 'redux/modules/model/holder';
import { holderDetailsSelector } from 'redux/selectors';
import { HolderForm } from 'smart-components';
import { listDetectables } from 'redux/modules/model/detectable';
import { PageContentTitle } from 'components';
import { withClientId } from 'hocs';
import { wsClient } from 'index';
import './index.scss';
import { notification } from 'elements';

const COMPONENT_CSS_CLASSNAME = 'directory-edit';
const bemE = suffix => `${COMPONENT_CSS_CLASSNAME}__${suffix}`;

class ContactEdit extends Component {
	state = {
		loading: false,
	};
	static propTypes = {
		clientId: PropTypes.string.isRequired,
		getHolder: PropTypes.func.isRequired,
		listDetectables: PropTypes.func.isRequired,
		match: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired,
	};

	componentDidMount() {
		const { clientId, getHolder, listDetectables, match } = this.props;
		const { clientReference } = match.params;
		getHolder({ clientId, clientReference, with: ['metadata'] });
		listDetectables({ clientId, assignment: clientReference });
	}

	handleSubmit = async actions => {
		const { history } = this.props;
		const operations = Object.freeze({
			addDetectable: async payload => {
				const response = await wsClient.request({
					messageType: 'core.detectable.add-detectable',
					payload,
				});
				if (response.messageType === 'core.error.already-exists') {
					await wsClient.request({
						messageType: 'core.detectable.edit-detectable',
						payload: {
							clientId: payload.clientId,
							detectableId: payload.detectableId,
							detectableType: payload.detectableType,
							changes: {
								active: payload.active,
								assignment: payload.assignment,
								description: payload.description,
							},
						},
					});
				}
			},
			editDetectable: async payload => {
				await wsClient.request({
					messageType: 'core.detectable.edit-detectable',
					payload,
				});
			},
			editHolder: async payload => {
				this.setState({ loading: true });
				const { changes, ...other } = payload;
				const { image, ...rest } = changes;
				const withOutImg = { changes: { ...rest }, ...other };
				await wsClient
					.request({
						messageType: 'core.holder.edit-holder',
						payload:
							payload.changes.image !== undefined
								? payload
								: withOutImg,
					})
					.then(res => {
						this.setState({ loading: false });
						notification.success({
							message: 'Success',
							description: 'Contact Successfully updated',
							placement: 'bottomLeft',
						});
					});
			},
			addAssignment: async payload => {
				await wsClient.request({
					messageType: 'attendance.schedule.put-assignment',
					payload,
				});
			},
			removeAssignment: async payload => {
				await wsClient.request({
					messageType: 'attendance.schedule.remove-assignment',
					payload,
				});
			},
		});

		try {
			actions.addDetectables &&
				actions.addDetectables.forEach(payload => {
					operations.addDetectable(payload);
				});
			actions.editDetectables &&
				actions.editDetectables.forEach(payload => {
					operations.editDetectable(payload);
				});
			actions.editHolder && operations.editHolder(actions.editHolder);
			actions.addAssignments &&
				actions.addAssignments.forEach(payload => {
					operations.addAssignment(payload);
				});
			actions.removeAssignments &&
				actions.removeAssignments.forEach(payload => {
					operations.removeAssignment(payload);
				});
			history.push(ROUTES.DIRECTORY)
		} catch (e) {
			notification.error({
				message: 'Error',
				description: 'Something went wrong',
				placement: 'bottomLeft',
			});
			console.error('error', e.message);
		}
		// history.push(this.backUrl)
	};

	render() {
		const { loading } = this.state;
		const { holder, detectablesList, history } = this.props;
		const initialValues = holder
		? {
			...holder,
			image: holder.imagePath,
			inactive: !holder.active,
			topSpender: holder.metadata ? !holder.metadata['Top Spender'] : false,
		}
		: null;
		return holder ? (
			<Row>
				<Col xs={24} md={10}>
					<p className={bemE('back')}>
						<a onClick={() => history.goBack()}>&laquo; Back</a>
					</p>
					<PageContentTitle>Edit Contact</PageContentTitle>
					<h2 className={bemE('subtitle')}>User Details</h2>
					<HolderForm
						initialValues={initialValues}
						onSubmit={this.handleSubmit}
						loading={loading}
					/>
				</Col>
			</Row>
		) : null;
	}
}

export const selector = createStructuredSelector({
	detectablesList: detectablesListSelector,
	holder: holderDetailsSelector,
});

export const actions = {
	getHolder,
	listDetectables,
};

export default compose(
	withRouter,
	withClientId,
	connect(
		selector,
		actions,
	),
)(ContactEdit);



// WEBPACK FOOTER //
// ./src/pages/directory/contact-edit/index.js